var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, Property, NotifyPropertyChanges, Event, ChildProperty } from '@syncfusion/ej2-base';
import { getComponent, closest, EventHandler, getUniqueID, isNullOrUndefined } from '@syncfusion/ej2-base';
import { Collection, Complex } from '@syncfusion/ej2-base';
import { Tab, Toolbar } from '@syncfusion/ej2-navigations';
import { Menu, Item, MenuItem } from '@syncfusion/ej2-navigations';
/**
 * Objects used for configuring the Ribbon tab header properties.
 *
 * @hidden
 */
export class RibbonHeader extends ChildProperty {
}
__decorate([
    Property('')
], RibbonHeader.prototype, "text", void 0);
__decorate([
    Property('')
], RibbonHeader.prototype, "iconCss", void 0);
__decorate([
    Property('left')
], RibbonHeader.prototype, "iconPosition", void 0);
/**
 * An array of object that is used to configure the Tab.
 *
 * @hidden
 */
export class RibbonItem extends ChildProperty {
}
__decorate([
    Complex({}, RibbonHeader)
], RibbonItem.prototype, "header", void 0);
__decorate([
    Collection([], Item)
], RibbonItem.prototype, "content", void 0);
__decorate([
    Property('')
], RibbonItem.prototype, "cssClass", void 0);
__decorate([
    Property(false)
], RibbonItem.prototype, "disabled", void 0);
/**
 * Represents Ribbon component.
 *
 * @hidden
 */
let Ribbon = class Ribbon extends Component {
    /**
     * Constructor for creating the widget.
     *
     * @param {RibbonModel} options - Specify the options
     * @param {string|HTMLDivElement} element -specify the element.
     */
    constructor(options, element) {
        super(options);
    }
    /**
     * For internal use only.
     *
     * @returns {void} - For internal use only.
     * @private
     */
    preRender() {
        /** */
    }
    /**
     * For internal use only.
     *
     * @returns {void} - For internal use only.
     * @private
     */
    render() {
        if (!this.element.id) {
            this.element.id = getUniqueID('ribbon');
        }
        this.renderRibbon();
    }
    /**
     * Destroys the component (detaches/removes all event handlers, attributes, classes, and empties the component element).
     *
     * {% codeBlock src='spreadsheet/destroy/index.md' %}{% endcodeBlock %}
     *
     * @function destroy
     * @returns {void} - Destroys the component
     */
    destroy() {
        const expandCollapseElem = this.element.querySelector('.e-drop-icon');
        if (expandCollapseElem) {
            expandCollapseElem.removeEventListener('click', this.ribbonExpandCollapse.bind(this));
        }
        if (this.menuItems.length) {
            const fileMenu = document.getElementById(`${this.element.id}_menu`);
            if (fileMenu) {
                const fileMenuObj = getComponent(fileMenu, 'menu');
                fileMenuObj.setProperties({ animationSettings: { effect: 'None' } }, true);
                fileMenuObj.destroy();
            }
        }
        if (this.toolbarObj) {
            this.toolbarObj.destroy();
        }
        if (this.tabObj) {
            this.tabObj.destroy();
        }
        this.element.innerHTML = '';
        this.toolbarObj = null;
        this.tabObj = null;
        super.destroy();
    }
    getTabItems() {
        const tabItems = [];
        if (this.menuItems.length) {
            tabItems.push({
                header: { text: this.initMenu(this.menuItems) },
                content: this.toolbarObj.element,
                cssClass: 'e-menu-tab'
            });
        }
        this.items.forEach((item) => {
            tabItems.push({
                header: item.header,
                content: this.toolbarObj.element
            });
        });
        return tabItems;
    }
    initMenu(menuItems) {
        const menu = this.createElement('ul', { id: `${this.element.id}_menu` });
        this.element.appendChild(menu);
        const menuObj = new Menu({
            cssClass: 'e-file-menu',
            items: menuItems,
            showItemOnClick: true,
            enableRtl: this.enableRtl,
            beforeOpen: (args) => {
                if (args.parentItem.text === menuItems[0].text) {
                    menuObj.showItemOnClick = false;
                }
                this.trigger('beforeOpen', args);
            },
            select: (args) => {
                this.trigger('fileMenuItemSelect', args);
            },
            beforeClose: (args) => {
                if (args.event && args.event.type === 'mouseover' && !closest(args.event.target, '.e-menu-popup')) {
                    args.cancel = true;
                    return;
                }
                this.trigger('beforeClose', args);
                if (!args.parentItem || args.parentItem.text === menuItems[0].text) {
                    menuObj.setProperties({ showItemOnClick: true }, true);
                }
            },
            beforeItemRender: (args) => {
                this.trigger('beforeFileMenuItemRender', args);
            },
            created: () => {
                menuObj.element.removeAttribute('tabindex');
                const fileItem = menuObj.element.querySelector('.e-menu-item');
                if (fileItem) {
                    fileItem.removeAttribute('tabindex');
                }
            }
        });
        menuObj.createElement = this.createElement;
        menuObj.appendTo(menu);
        return menu.parentElement;
    }
    renderRibbon() {
        const tabElement = this.createElement('div');
        const tBarElement = this.createElement('div');
        let isShortcut;
        this.toolbarObj = new Toolbar({
            items: this.items[this.selectedTab].content,
            enableRtl: this.enableRtl,
            clicked: (args) => this.trigger('clicked', args)
        });
        this.toolbarObj.createElement = this.createElement;
        this.toolbarObj.appendTo(tBarElement);
        this.tabObj = new Tab({
            selectedItem: this.getIndex(this.selectedTab),
            animation: { next: { duration: 0 }, previous: { duration: 0 } },
            items: this.getTabItems(),
            enableRtl: this.enableRtl,
            selecting: (args) => {
                if (args.isSwiped) {
                    args.cancel = true;
                    return;
                }
                isShortcut = args.event && args.event.isShortcut;
                if (this.menuItems.length && args.selectingIndex === 0) {
                    args.cancel = true;
                    if ((!args.event || isShortcut || args.event.type === 'keydown') && args.selectingItem) {
                        const fileMenu = args.selectingItem.querySelector('.e-file-menu .e-menu-item');
                        if (fileMenu) {
                            fileMenu.click();
                        }
                    }
                }
                else {
                    if (args.selectingIndex === this.getIndex(this.selectedTab)) {
                        return;
                    }
                    this.updateToolbar(this.getIndex(args.selectingIndex, true));
                    this.toolbarObj.dataBind();
                    this.refreshTemplateItems(this.toolbarObj); // To refresh template items in the toolbar.
                    if (this.element.classList.contains('e-collapsed')) {
                        EventHandler.remove(args.selectedItem, 'click', this.ribbonExpandCollapse);
                    }
                    let eventArgs;
                    if (this.menuItems.length) {
                        eventArgs = Object.assign({}, args);
                        eventArgs.selectingIndex -= 1;
                        eventArgs.selectedIndex -= 1;
                    }
                    else {
                        eventArgs = args;
                    }
                    this.trigger('selecting', eventArgs);
                }
            },
            selected: (args) => {
                if (!args.isInteracted && !isShortcut) {
                    args.preventFocus = true;
                }
                if (args.selectedIndex === this.getIndex(this.selectedTab)) {
                    return;
                }
                this.setProperties({ 'selectedTab': this.getIndex(args.selectedIndex, true) }, true);
                if (this.element.classList.contains('e-collapsed')) {
                    this.element.classList.remove('e-collapsed');
                    this.trigger('expandCollapse', { element: this.toolbarObj.element, expanded: true });
                }
            },
            created: () => {
                this.toolbarObj.refreshOverflow();
            }
        });
        this.element.appendChild(tabElement);
        this.tabObj.createElement = this.createElement;
        this.tabObj.appendTo(tabElement);
        const collapseBtn = this.createElement('span', { className: 'e-drop-icon e-icons' });
        collapseBtn.addEventListener('click', this.ribbonExpandCollapse.bind(this));
        this.element.appendChild(collapseBtn);
    }
    ribbonExpandCollapse(e) {
        const eventArgs = { element: this.toolbarObj.element, expanded: true };
        let activeTab;
        if (this.element.classList.contains('e-collapsed')) {
            activeTab = this.tabObj.element.querySelector('.e-tab-header').getElementsByClassName('e-toolbar-item')[this.tabObj.selectedItem];
            this.element.classList.remove('e-collapsed');
            activeTab.classList.add('e-active');
            EventHandler.remove(activeTab, 'click', this.ribbonExpandCollapse);
            this.trigger('expandCollapse', eventArgs);
        }
        else {
            activeTab = this.tabObj.element.querySelector('.e-tab-header .e-toolbar-item.e-active');
            this.element.classList.add('e-collapsed');
            eventArgs.expanded = false;
            activeTab.classList.remove('e-active');
            EventHandler.add(activeTab, 'click', this.ribbonExpandCollapse, this);
            this.trigger('expandCollapse', eventArgs);
        }
    }
    getIndex(index, decrement) {
        return this.menuItems.length ? (decrement ? index - 1 : index + 1) : index;
    }
    updateToolbar(index) {
        this.toolbarObj.items = this.items[index].content;
        this.toolbarObj.dataBind();
    }
    refreshTemplateItems(toolbarInstance) {
        if (this.spreadInstance && this.spreadInstance.isReact && this.spreadInstance.portals &&
            toolbarInstance && toolbarInstance.portals) {
            this.spreadInstance.portals = this.spreadInstance.portals.concat(toolbarInstance.portals);
            this.spreadInstance['renderReactTemplates']();
        }
    }
    /**
     * To enable / disable the ribbon menu items.
     *
     * @param {string[]} items - Items that needs to be enabled / disabled.
     * @param {boolean} enable - Set `true` / `false` to enable / disable the menu items.
     * @param {boolean} isUniqueId - Set `true` if the given menu items `text` is a unique id.
     * @returns {void} - To enable / disable the ribbon menu items.
     */
    enableMenuItems(items, enable = true, isUniqueId) {
        if (!this.menuItems.length) {
            return;
        }
        getComponent(document.getElementById(`${this.element.id}_menu`), 'menu').enableItems(items, enable, isUniqueId);
    }
    /**
     * To show/hide the menu items in Ribbon.
     *
     * @param {string[]} items - Specifies the menu items text which is to be show/hide.
     * @param {boolean} hide - Set `true` / `false` to hide / show the menu items.
     * @param {boolean} isUniqueId - Set `true` if the given menu items `text` is a unique id.
     * @returns {void} - To show/hide the menu items in Ribbon.
     */
    hideMenuItems(items, hide = true, isUniqueId) {
        if (!this.menuItems.length) {
            return;
        }
        const menuInstance = getComponent(document.getElementById(`${this.element.id}_menu`), 'menu');
        if (hide) {
            menuInstance.hideItems(items, isUniqueId);
        }
        else {
            menuInstance.showItems(items, isUniqueId);
        }
    }
    /**
     * To add custom menu items.
     *
     * @param {MenuItemModel[]} items - Specifies the Ribbon menu items to be inserted.
     * @param {string} text - Specifies the existing file menu item text before / after which the new file menu items to be inserted.
     * @param {boolean} insertAfter - Set `false` if the `items` need to be inserted before the `text`.
     * By default, `items` are added after the `text`.
     * @param {boolean} isUniqueId - Set `true` if the given menu items `text` is a unique id.
     * @returns {void} - To add custom menu items.
     */
    addMenuItems(items, text, insertAfter = true, isUniqueId) {
        if (!this.menuItems.length) {
            return;
        }
        const menuInstance = getComponent(document.getElementById(`${this.element.id}_menu`), 'menu');
        if (insertAfter) {
            menuInstance.insertAfter(items.reverse(), text, isUniqueId);
        }
        else {
            menuInstance.insertBefore(items, text, isUniqueId);
        }
    }
    /**
     * To show/hide the Ribbon tabs.
     *
     * @param {string[]} tabs - Specifies the tab header text which needs to be shown/hidden.
     * @param {boolean} hide - Set `true` / `false` to hide / show the ribbon tabs.
     * @returns {void} - To show/hide the Ribbon tabs.
     */
    hideTabs(tabs, hide = true) {
        let idx;
        let activeTab;
        let stateChanged;
        let isAllHidden;
        if (!hide) {
            isAllHidden = this.isAllHidden();
        }
        tabs.forEach((tab) => {
            idx = this.getTabIndex(tab, -1);
            if (idx > -1) {
                if (hide) {
                    if (!this.items[idx].cssClass.includes(' e-hide')) {
                        this.items[idx].cssClass = `${this.items[idx].cssClass} e-hide`;
                        this.tabObj.items[this.getIndex(idx)].cssClass = this.items[idx].cssClass;
                        if (activeTab === undefined && idx === this.selectedTab) {
                            activeTab = true;
                        }
                        stateChanged = true;
                    }
                }
                else {
                    if (this.items[idx].cssClass.includes(' e-hide')) {
                        this.items[idx].cssClass = this.items[idx].cssClass.replace(' e-hide', '');
                        this.tabObj.items[this.getIndex(idx)].cssClass = this.items[idx].cssClass;
                        if (activeTab === undefined && idx === this.selectedTab) {
                            activeTab = true;
                        }
                        stateChanged = true;
                    }
                }
            }
        });
        this.setProperties({ 'items': this.items }, true);
        // eslint-disable-next-line no-self-assign
        this.tabObj.items = this.tabObj.items;
        this.tabObj.dataBind();
        if (hide) {
            isAllHidden = this.isAllHidden();
            if (isAllHidden) {
                activeTab = false;
            }
        }
        if (!hide && isAllHidden) {
            activeTab = activeTab ? false : true;
        }
        if (stateChanged && isAllHidden) {
            if (this.element.classList.contains('e-collapsed')) {
                this.element.classList.remove('e-collapsed');
                this.element.querySelector('.e-drop-icon').classList.remove('e-hide');
            }
            else {
                this.element.classList.add('e-collapsed');
                this.element.querySelector('.e-drop-icon').classList.add('e-hide');
            }
        }
        if (activeTab) {
            for (let i = 0; i < this.items.length; i++) {
                if (!this.items[i].cssClass.includes(' e-hide')) {
                    this.tabObj.selectedItem = this.getIndex(i);
                    this.tabObj.dataBind();
                    break;
                }
            }
        }
    }
    isAllHidden() {
        let allHidden = true;
        for (let i = 0; i < this.items.length; i++) {
            if (!this.items[i].cssClass.includes(' e-hide')) {
                allHidden = false;
                break;
            }
        }
        return allHidden;
    }
    /**
     * To enable / disable the Ribbon tabs.
     *
     * @param {string[]} tabs - Specifies the tab header text which needs to be enabled / disabled.
     * @param {boolean} enable - Set `true` / `false` to enable / disable the ribbon tabs.
     * @returns {void} - To enable / disable the Ribbon tabs.
     */
    enableTabs(tabs, enable = true) {
        tabs.forEach((tab) => {
            let idx = (this.getTabIndex(tab, -1));
            if (idx > -1) {
                this.items[idx].disabled = !enable;
                idx = this.getIndex(idx);
                this.tabObj.enableTab(idx, enable);
            }
        });
        this.setProperties({ 'items': this.items }, true);
    }
    /**
     * To add custom tabs.
     *
     * @param {RibbonItemModel[]} items - Specifies the Ribbon tab items to be inserted.
     * @param {string} insertBefore - Specifies the existing Ribbon header text before which the new tabs will be inserted.
     * If not specified, the new tabs will be inserted at the end.
     * @returns {void} - To add custom tabs.
     */
    addTabs(items, insertBefore) {
        let idx = this.getTabIndex(insertBefore);
        let tab;
        items.forEach((item) => {
            item = new RibbonItem(this.items[0], 'items', item, true);
            this.items.splice(idx, 0, item);
            tab = { header: item.header, content: this.toolbarObj.element };
            if (item.cssClass) {
                tab.cssClass = item.cssClass;
            }
            if (item.disabled) {
                tab.disabled = item.disabled;
            }
            this.tabObj.addTab([tab], this.getIndex(idx));
            idx++;
        });
        this.setProperties({ 'items': this.items }, true);
        this.setProperties({ 'selectedTab': this.getIndex(this.tabObj.selectedItem, true) }, true);
    }
    getTabIndex(headerText, idx = this.items.length) {
        if (headerText) {
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].header.text === headerText) {
                    idx = i;
                    break;
                }
            }
        }
        return idx;
    }
    /**
     * To add the custom items in Ribbon toolbar.
     *
     * @param {string} tab - Specifies the ribbon tab header text under which the specified items will be inserted..
     * @param {ItemModel[]} items - Specifies the ribbon toolbar items that needs to be inserted.
     * @param {number} index - Specifies the index text before which the new items will be inserted.
     * @returns {void} - To add the custom items in Ribbon toolbar.
     * If not specified, the new items will be inserted at the end of the toolbar.
     */
    addToolbarItems(tab, items, index) {
        const tabIdx = this.getTabIndex(tab);
        if (isNullOrUndefined(index)) {
            index = this.items[tabIdx].content.length;
        }
        items.forEach((item) => {
            item = new Item(this.items[tabIdx].content[0], 'content', item, true);
            this.items[tabIdx].content.splice(index, 0, item);
            index++;
        });
        this.setProperties({ 'items': this.items }, true);
        if (tabIdx === this.selectedTab && items.length) {
            this.updateToolbar(tabIdx);
        }
    }
    /**
     * Enables or disables the specified Ribbon toolbar items or all ribbon items.
     *
     * @param {string} tab - Specifies the ribbon tab header text under which the toolbar items need to be enabled / disabled.
     * @param {number[]} items - Specifies the toolbar item indexes / unique id's which needs to be enabled / disabled.
     * If it is not specified the entire toolbar items will be enabled / disabled.
     * @param  {boolean} enable - Boolean value that determines whether the toolbar items should be enabled or disabled.
     * @param  {boolean} isPublic - Boolean value that determines whether the toolbar items are enabled or disabled from public method or not.
     * @returns {void} - Enables or disables the specified Ribbon toolbar items or all ribbon items.
     */
    enableItems(tab, items, enable, isPublic) {
        if (enable === undefined) {
            enable = true;
        }
        if (items) {
            const tabIdx = this.getTabIndex(tab, -1);
            if (tabIdx < 0) {
                return;
            }
            let isEnabled;
            for (let i = 0; i < items.length; i++) {
                if (typeof items[i] === 'string') {
                    for (let j = 0; j < this.items[tabIdx].content.length; j++) {
                        if (this.items[tabIdx].content[j].id === items[i]) {
                            items[i] = j;
                            break;
                        }
                    }
                }
                if (typeof items[i] === 'string') {
                    if (items.length - 1 > i) {
                        continue;
                    }
                    else {
                        return;
                    }
                }
                const itemContent = this.items[tabIdx].content[items[i]];
                isEnabled = enable;
                if (isPublic) {
                    itemContent.isManuallyEnabled = enable;
                }
                else if (enable && itemContent.isManuallyEnabled !== undefined) {
                    isEnabled = itemContent.isManuallyEnabled;
                }
                itemContent.disabled = !isEnabled;
                this.setProperties({ 'items': this.items }, true);
                if (tabIdx === this.selectedTab) {
                    this.toolbarObj.enableItems(items[i], isEnabled);
                }
            }
        }
        else {
            this.toolbarObj.disable(!enable);
        }
    }
    /**
     * To show/hide the existing Ribbon toolbar items.
     *
     * @param {string} tab - Specifies the ribbon tab header text under which the specified items need to be hidden / shown.
     * @param {number[]} indexes - Specifies the toolbar indexes which needs to be shown/hidden from UI.
     * @param {boolean} hide - Set `true` / `false` to hide / show the toolbar items.
     * @returns {void} - To show/hide the existing Ribbon toolbar items.
     */
    hideToolbarItems(tab, indexes, hide = true) {
        let tabIdx;
        let tabContent;
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].header.text === tab) {
                tabIdx = i;
                indexes.forEach((idx) => {
                    tabContent = this.items[tabIdx].content[idx];
                    if (tabContent) {
                        if (hide) {
                            if (!tabContent.cssClass.includes(' e-hide')) {
                                tabContent.cssClass = tabContent.cssClass + ' e-hide';
                            }
                        }
                        else {
                            if (tabContent.cssClass.includes(' e-hide')) {
                                tabContent.cssClass = tabContent.cssClass.replace(' e-hide', '');
                            }
                        }
                    }
                });
                break;
            }
        }
        this.setProperties({ 'items': this.items }, true);
        if (tabIdx !== undefined && tabIdx === this.selectedTab) {
            this.updateToolbar(tabIdx);
        }
    }
    /**
     * Get component name.
     *
     * @returns {string} - Get component name.
     * @private
     */
    getModuleName() {
        return 'ribbon';
    }
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Get the properties to be maintained in the persisted state.
     * @private
     */
    getPersistData() {
        return this.addOnPersist([]);
    }
    /**
     * Called internally if any of the property value changed.
     *
     * @param {RibbonModel} newProp - Specify the new properties
     * @param {RibbonModel} oldProp - specify the old properties.
     * @returns {void} - if any of the property value changed.
     * @private
     */
    onPropertyChanged(newProp, oldProp) {
        for (const prop of Object.keys(newProp)) {
            switch (prop) {
                case 'selectedTab':
                    this.tabObj.selectedItem = this.getIndex(newProp.selectedTab);
                    this.tabObj.dataBind();
                    break;
            }
        }
    }
};
__decorate([
    Property('')
], Ribbon.prototype, "cssClass", void 0);
__decorate([
    Property(true)
], Ribbon.prototype, "menuType", void 0);
__decorate([
    Collection([], MenuItem)
], Ribbon.prototype, "menuItems", void 0);
__decorate([
    Property(0)
], Ribbon.prototype, "selectedTab", void 0);
__decorate([
    Collection([], RibbonItem)
], Ribbon.prototype, "items", void 0);
__decorate([
    Property(null)
], Ribbon.prototype, "spreadInstance", void 0);
__decorate([
    Event()
], Ribbon.prototype, "selecting", void 0);
__decorate([
    Event()
], Ribbon.prototype, "fileMenuItemSelect", void 0);
__decorate([
    Event()
], Ribbon.prototype, "beforeFileMenuItemRender", void 0);
__decorate([
    Event()
], Ribbon.prototype, "beforeOpen", void 0);
__decorate([
    Event()
], Ribbon.prototype, "beforeClose", void 0);
__decorate([
    Event()
], Ribbon.prototype, "selectFormat", void 0);
__decorate([
    Event()
], Ribbon.prototype, "clicked", void 0);
__decorate([
    Event()
], Ribbon.prototype, "created", void 0);
__decorate([
    Event()
], Ribbon.prototype, "expandCollapse", void 0);
Ribbon = __decorate([
    NotifyPropertyChanges
], Ribbon);
export { Ribbon };
